import { Result, Button } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import { useSimulation } from '../../context/SimulationContext';
import { useNavigate, useParams } from 'react-router-dom';
import './SessionEndScreen.scss';

const outcomeConfig = {
  success: {
    icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    title: 'Simulation Complete',
  },
  early_success: {
    icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
    title: 'Simulation Complete — Early Success',
  },
  failure: {
    icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
    title: 'Simulation Ended',
  },
  max_turns: {
    icon: <ClockCircleOutlined style={{ color: '#faad14' }} />,
    title: 'Simulation Complete — Maximum Turns Reached',
  },
};

function SessionEndScreen() {
  const { sessionEnd } = useSimulation();
  const navigate = useNavigate();
  const { slug } = useParams();

  const handleReturn = () =>
    navigate(slug ? `/${slug}/requirements?view=assessment` : '/');

  // Previously completed session — no live end event available
  if (!sessionEnd) {
    return (
      <div className="session-end-screen">
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title="Assessment Submitted"
          subTitle="You have already completed this simulation. The recruitment team will review your performance and get back to you."
          extra={
            <Button type="primary" onClick={handleReturn}>
              Return to Assessment
            </Button>
          }
        />
      </div>
    );
  }

  const config = outcomeConfig[sessionEnd.outcome] ?? outcomeConfig.failure;

  return (
    <div className="session-end-screen">
      <Result
        icon={config.icon}
        title={config.title}
        subTitle={`You completed ${sessionEnd.totalTurns} turns. Your results are being processed.`}
        extra={
          <Button type="primary" onClick={handleReturn}>
            Return to Assessment
          </Button>
        }
      />
    </div>
  );
}

export default SessionEndScreen;
